// @ts-strict-ignore
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Icon, Input } from '@node-space/ui-components'
import { AddBeneficiaryFormErrors, BaseFormProps, ValidateIbanResponse } from 'types/beneficiaries'

interface IbanFormFieldsProps extends BaseFormProps {
  bic: string
  errors: AddBeneficiaryFormErrors
  iban: string
  isValidatingIban: boolean
  isSepaSupported: boolean
  ibanValidationData?: ValidateIbanResponse
  onIbanInputBlur: () => void
}

export const IbanFormFields = ({
  bic,
  errors,
  iban,
  isValidatingIban,
  ibanValidationData,
  isSepaSupported,
  handleChange,
  register,
  onIbanInputBlur,
}: IbanFormFieldsProps) => {
  const { t } = useTranslation()

  const isValid =
    !!ibanValidationData?.bankAccount?.accountNumber &&
    isSepaSupported &&
    !ibanValidationData?.validationFailed.length
  return (
    <>
      <Box paddingB={16}>
        <Input
          {...register('iban')}
          label={t('iban')}
          placeholder={t('enterAccountNumber')}
          inputMode="text"
          name="iban"
          test-id="input-iban"
          errorText={errors?.iban?.message}
          error={!!errors?.iban}
          value={iban}
          onChange={event => handleChange('iban', event?.target?.value)}
          onBlur={onIbanInputBlur}
          IconButton={
            isValid ? <Button variant="ghost" iconElement={<Icon name="Check" />} /> : null
          }
          iconPosition="right"
          loading={isValidatingIban}
        />
      </Box>
      <Box paddingB={16}>
        <Input
          {...register('bic')}
          label={t('bic')}
          placeholder={t('enterCode')}
          inputMode="text"
          name="bic"
          test-id="input-bic"
          errorText={errors?.bic?.message}
          error={!!errors?.bic}
          value={bic}
          onChange={event => handleChange('bic', event?.target?.value)}
          loading={isValidatingIban}
        />
      </Box>
    </>
  )
}
